export default __webpack_public_path__ + "static/media/REFERRALPATIENT.c61fc97f.png";